export default "__VITE_ASSET__08ad5fe5__"